import React from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

export interface ConfirmDiscardModalProps {
  show: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
  /** What would be lost, e.g. "your changes to TT0001". */
  subject?: string;
}

/**
 * Asked before unsaved changes are thrown away (CONF-01, EDIT-05): Discard Changes is the red
 * destructive action, Keep Editing the outline one.
 */
export const ConfirmDiscardModal: React.FC<ConfirmDiscardModalProps> = ({ show, onDiscard, onKeepEditing, subject }) => (
  <Modal show={show} onHide={onKeepEditing} size="sm">
    <Modal.Header closeButton>
      <Modal.Title>Discard Changes?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="tw-mb-0 tw-text-sm">
        You have unsaved changes{subject ? ` to ${subject}` : ''}. If you leave now they will be lost.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onKeepEditing}>
        Keep Editing
      </Button>
      <Button variant="danger" onClick={onDiscard}>
        Discard Changes
      </Button>
    </Modal.Footer>
  </Modal>
);
